class QikifyMenuOverride {
	constructor(menuEl, menuItems) {
		this.el = menuEl;
		this.subMenuItems = Array.from(
			this.el.querySelectorAll(
				".tmenu_masonry_row > ul:not(.tmenu_masonry_placeholder) .tmenu_item_level_2.tmenu_item_has_child"
			)
		);
		this.topMenuItems = Array.from(
			this.el.querySelectorAll(
				".tmenu_initialized > ul.tmenu_nav > .tmenu_item_level_0 > a"
			)
		);

		this.init();
	}

	init() {
		this.subMenuItems.forEach((i) => {
			// cloning each element removes its event listeners which were interfering with our desired ux
			const c = i.cloneNode(true);
			this.addToggleEl(c);

			i.parentElement.replaceChild(c, i);
		});

		// add hover and focus listeners for top level menu items
		this.topMenuItems.forEach((t) => {
			function showSubmenu() {
				t.parentElement.classList.add("tmenu_item_active");
			}

			function hideSubmenu() {
				t.parentElement.classList.remove("tmenu_item_active");
			}

			t.parentElement.addEventListener("mouseenter", showSubmenu);
			t.parentElement.addEventListener("mouseleave", hideSubmenu);
			t.addEventListener("focus", showSubmenu);
			t.addEventListener("blur", hideSubmenu);
		});
	}

	addToggleEl(i) {
		const btn = document.createElement("button");
		btn.innerHTML = `
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
				<path d="M2 2L8 8L14 2" stroke="#138075" stroke-width="2" stroke-linecap="square"/>
			</svg>
			<span class="visually-hidden">Toggle Submenu</span>
		`;
		btn.classList.add("submenu-toggle");
		btn.addEventListener("click", () => {
			i.classList.toggle(
				"tmenu_submenu_open",
				!i.classList.contains("tmenu_submenu_open")
			);
		});

		i.append(btn);
	}
}

function initializeMenu(menuEl, menuItems) {
	menuItems.forEach((i) => {
		const el = document.createElement("span");
		el.innerText = "";

		i.appendAfter(el, i.children[0]);
	});
}

let menu = document.querySelector(".tmenu_navbar");
let menuItems = menu?.querySelectorAll(
	".tmenu_masonry_row > ul:not(.tmenu_masonry_placeholder) .tmenu_item_level_2.tmenu_item_has_child"
);

if (menu && menuItems.length > 0) {
	new QikifyMenuOverride(menu, menuItems);
} else {
	const qikifyInterval = setInterval(() => {
		menu = document.querySelector(".tmenu_navbar");
		menuItems = menu?.querySelectorAll(
			".tmenu_masonry_row > ul:not(.tmenu_masonry_placeholder) .tmenu_item_level_2.tmenu_item_has_child"
		);

		if (menu && menuItems.length > 0) {
			clearInterval(qikifyInterval);
			new QikifyMenuOverride(menu, menuItems);
		}
	}, 64);
}
